'use strict';

import {memberModel} from "../../models/membermodel.js";

export class MembersCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	
	members = [];
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.loadData();
	}
	
	loadData(){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				this.promise = this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'GET',
					params: {}
				}).then((response) => {
					if(response.data.success){
						this.setData(response.data.data);
					}
				}, () => {});
			}
	}
	
	setData(data){
		this.members = [];
		for(let row of data){
			this.members.push(new memberModel(row, this.$filter, this.jsDataService));
		}
	}
	
	removeMember(ev, member){
		if(this.jsDataService.get('cfgRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: member.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}
	
	editMember(ev, member){
		this.memberEditor(ev, member);
	}
	
	addMember(ev){
		this.memberEditor(ev, new memberModel({id: 0}, this.$filter, this.jsDataService));
	}
	
	memberEditor(ev, member){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "member", "allmembers", this.memberEditorDialogCtrl],
			templateUrl: 'application/member_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				member: member,
				allmembers: this.members
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgSaveUrl')){
				const data = {
					actions: results.actions,
					member_email: results.member_email,
					user_id: results.user_id,
					member_id: results.member_id
				};
				if(this.jsDataService.get('isEsfaUser')){
					data.confirmed = results.sign_confirmed;
				}
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveUrl'),
					method: 'POST',
					data: data
				}).then((response) => {
					if(response.data.success){
						this.loadData();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}
	
	memberEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, member, allmembers){
		$scope.member = angular.copy(member);
		$scope.member.member_id = $scope.member.id;
		$scope.isSearch = (typeof($scope.member.id) === 'undefined' || $scope.member.id < 1);
		const classif = jsDataService.get('cfgClassif', {});
		$scope.permits = [];
		$scope.userdata = [];
		$scope.searchString;
//		$scope.gloViewAction = false;
		
		function isSet(action){
			if(typeof($scope.member.actions) === 'undefined'){
				return false;
			}
			if($scope.member.actions.length < 1){
				return false;
			}
			return ($scope.member.actions.indexOf(action) > -1);
		}
		
		for(let prmt of classif.site_actions){
			let obj = angular.copy(prmt);
			obj.value = isSet(prmt.id);
			$scope.permits.push(obj);
		}

		function getUsers(){
			if(jsDataService.get('cfgUsersUrl')){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('cfgUsersUrl'),
					method: 'GET',
					params: {
						query: $scope.searchString
					}
				}).then((response) => {
					if(response.data.success){
						setData(response.data.data);
					}
				}, () => {});
			}
		}
		
		function inMembersByUid(userId){
			return ($filter('filter')(allmembers, {user_id: userId}, true).length > 0);
		}
		function inMembersByEmail(email){
			return ($filter('filter')(allmembers, {member_email: email}, true).length > 0 || $filter('filter')(allmembers, {email: email}, true).length > 0);
		}
		
		function setData(data){
			$scope.resetResults();
			for(let u of data){
				u.member_id = 0;
				u.type = 'user';
				u.user_id = u.id;
				u.member = u.name + ' ' + u.lastname + ', ' + u.email;
				u.inlist = (inMembersByUid(u.user_id) || inMembersByEmail(u.email));
				$scope.userdata.push(u);
			}
			if($scope.userdata.length < 1 && /^.+@.+\..+$/.test($scope.searchString) && !inMembersByEmail($scope.searchString)){
				let u = {
					member_id: 0,
					user_id: 0,
					type: 'email',
					member_email: $scope.searchString,
					member: $scope.searchString
				};
				$scope.userdata.push(u);
			}
		}
		if($scope.isSearch){
			$scope.$watch("searchString", (nval, oval) => {
				if(typeof(nval) !== 'undefined' && nval !== ''){
					getUsers();
				}
				else{
					$scope.resetResults();
				}
			});
		}
		
		
		$scope.resetResults = function(){
			$scope.userdata = [];
		};
		
		$scope.addMember = function(user){
			user.actions = [];
			$scope.member = new memberModel(user, $filter, jsDataService);
//			$scope.resetResults();
			$scope.searchString = '';
		};
		
		$scope.hasResults = function(){
			return $scope.userdata.length > 0;
		};
		
		$scope.isValid = function(){
			if((typeof($scope.member.member_email) === 'undefined' || $scope.member.member_email === '') && (typeof($scope.member.user_id) === 'undefined' || $scope.member.user_id < 1)){
				return false;
			}
			return $scope.hasActions();
		};
		
		$scope.hasActions = function(){
			return ($filter('filter')($scope.permits, {value: true}, true).length > 0);
		};
		
		$scope.actionChange = function(){
			if($filter('filter')($scope.permits, {value: true, id: '!preview'}, true).length > 0){
				$filter('filter')($scope.permits, {id: 'preview'}, true)[0].value = true;
			}
			if($filter('filter')($scope.permits, {value: true, id: 'commwrite'}, true).length > 0){
				$filter('filter')($scope.permits, {id: 'commaccess'}, true)[0].value = true;
			}

			if($filter('filter')($scope.permits, {value: true, id: 'sign'}, true).length > 0){
				$filter('filter')($scope.permits, {id: 'commwrite'}, true)[0].value = true;
			}
		};

		$scope.isEsfaUser = function(){
			return jsDataService.get('isEsfaUser');
		};

		$scope.actionChange();
		
		
		$scope.ctrlDisabledAction = function(action){
			if(action.id === 'commaccess') {
				return ($filter('filter')($scope.permits, {value: true, id: 'commwrite'}, true).length > 0);
			}
			if(action.id !== 'preview'){
				return false;
			}
			return ($filter('filter')($scope.permits, {value: true, id: '!preview'}, true).length > 0);
		};
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function(){
			if($scope.isValid()){
				$scope.member.actions = [];
				for(let prm of $scope.permits){
					if(prm.value){
						$scope.member.actions.push(prm.id);
					}
				}
				$mdDialog.hide($scope.member);
			}
		}; 
	}
}